import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { transformFields } from '@core/utils/methods';
import { SiteBrowse } from '@models/interfaces';
import { Details } from '@shared/modules/details';
import { ProjectManagementSelectors } from '@store/selectors';

export const ProjectManagementDetails: FC<RouteComponentProps> = (
  props: RouteComponentProps,
) => {
  const site = useSelector(ProjectManagementSelectors.getPMDetailsInfo);

  const transformedSite = useMemo(
    () => transformFields<SiteBrowse>(site, ['towerOwner', 'riskCategory']),
    [site],
  );

  return (
    <Details {...props} fuzeID destroyInactiveTabPane site={transformedSite} />
  );
};
